import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { columnsDef } from 'src/app/interfaces/columnsDef';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-form-view-date',
    templateUrl: './form-view-date.component.html',
    styleUrls: ['./form-view-date.component.css'],
    standalone: false
})
export class FormViewDateComponent implements OnInit {

  config: columnsDef;
  group: UntypedFormGroup;
  row: Object;
  tabindex:string;
  entityName:string;
  entityDesc:string;
  canConfig:boolean = false;
  toolTipText = null;
  
  @Output() editEvent:EventEmitter<boolean> = new EventEmitter();
  @Output() blurEvent:EventEmitter<boolean> = new EventEmitter();
  bluring(event){
      this.blurEvent.next(event)
  }

  constructor(private _datepipe:DatePipe ) { }

  setDate(dateObject) {
    //this._datepipe.transform(dateObject.value, 'yyyy/MM/dd HH:mm:ss.SSS');
  }

  ngOnInit() {
      
  }

  editing(){
    this.editEvent.next(true)
  }
}
